import { SHOW_FREEQUOTE } from '../Actions/types'

const initialState = {
    showfreequote: false
}

export default function (state = initialState, action) {
    switch(action.type) {
        case SHOW_FREEQUOTE: 
        console.log('reducer test');
            return {
             ...state,
               showfreequote: action.payload
            };
        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/Reducers/freequoteReducer.js